import { AreaTeamAvailabilityBase } from './base/area-team-availability-base';

export class AreaTeamAvailability extends AreaTeamAvailabilityBase { }